export const comments_5053766 = {"data":{"data":[],"links":{}}}